module.exports = __webpack_public_path__ + "images/nerd-face-gif-2.gif";